import { apiClient } from "../apiClient";
import toast from "../components/base/Toast";
import { endpoints } from "../configs";
import { fetchList } from "./table";

import {
  REQUEST_UPDATE_EXPERT,
  RECEIVE_UPDATE_EXPERT,
  EXPERT_UPDATE_ERROR
} from "../actionType/Constants";
import { isBadRequest } from "../common/http";

/**
 * Request for updating Expert
 */
export function requestUpdateExpert() {
  return {
    type: REQUEST_UPDATE_EXPERT
  };
}

/**
 * Receive for updating Expert
 */
export function receiveUpdateExpert() {
  return {
    type: RECEIVE_UPDATE_EXPERT
  };
}

/**
 * Receive for error updating Expert
 */
export function expertUpdateError(error) {
  return {
    type: EXPERT_UPDATE_ERROR,
    error
  };
}

/**
 * Update Expert
 *
 * @param id
 * @param data
 * @returns {function(...[*]=)}
 */
export function updateExpert(id, data, params) {
  return dispatch => {
    dispatch(requestUpdateExpert());
    apiClient
      .put(`${endpoints().expertAPI}/status/approve/${id}`, data)
      .then(response => {
        let successMessage;
        if (response && response.data) {
          successMessage = response.data.message;
        }
        toast.success(successMessage);
      })
      .then(() => {
        dispatch(
          fetchList(
            "pendingExperts",
            `${endpoints().expertAPI}/search`,
            1,
            10,
            params ? params : {}
          )
        );
        dispatch(
          fetchList(
            "approvedExperts",
            `${endpoints().expertAPI}/search`,
            1,
            10,
            {
              marketplaceStatus: "Approved"
            }
          )
        );
        dispatch(receiveUpdateExpert());
      })
      .catch(error => {
        dispatch(expertUpdateError(error));

        if (isBadRequest(error)) {
          let errorMessage;
          const errorRequest = error.response.request;
          if (errorRequest && errorRequest.response) {
            errorMessage = JSON.parse(errorRequest.response).message;
          }
          toast.error(error.response.data.message);
          console.error(errorMessage);
        }
      });
  };
}
